export default __webpack_public_path__ + "static/media/Solutions.c8021614.svg";